module.exports = __webpack_public_path__ + "media/seratus.7ffbb9e4.mp3";